import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import IImportationDetails, { IImportationDetailsInput } from "@/interfaces/importation-details";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class ImportationDetailsService {
  private baseUrl = "api/v1/importprocessline";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IImportationDetails>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const importationDetails = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return importationDetails;
  }

  async filter(
    filter: IFilter<IImportationDetails>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IImportationDetails>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });
    return response;
  }

  async create(formData: IImportationDetailsInput): Promise<IImportationDetails> {
    return await httpRequest.post(this.baseUrl, formData);
  }

  async getById(importationId: number): Promise<IImportationDetails> {
    return await httpRequest.get(`${this.baseUrl}/${importationId}`);
  }

  async update(formData: IImportationDetailsInput, importationId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${importationId}`, formData);
  }

  async delete(importationId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${importationId}`);
  }
}

const importationDetailsService = new ImportationDetailsService();
export default importationDetailsService;
